import { AuthService } from "../../../../services/auth.service"
import { ApiService } from "../../../../services/api.service"
import { getRoleSetState } from "./getRoleSetState"
import { navigate } from "@reach/router"
import * as decode from "jwt-decode"

export const adLogin = (adToken, setCookie, setState, logout) => {
  AuthService.adLogin(adToken).then((res: any) => {
    if (res.status === 200) {
      res.data.authToken &&
        setCookie("hallenToken", res.data.authToken, {
          maxAge: 3600,
          path: "/",
        })
      const { name, roleId, userID, empID } = decode(res.data.authToken)
      const employeeParams = new URLSearchParams({
        employeeID: "me",
      })
      ApiService.get(process.env.EMPLOYEE_DETAIL, employeeParams).then(
        (response: any) => {
          if (response.status === 200) {
            setState(prevState => ({
              ...prevState,
              employeeDetails: { ...response.data.data[0] },
            }))
          }
        }
      )
      getRoleSetState(
        name,
        roleId,
        userID,
        empID,
        setState,
        logout,
        res.data.authToken,
        null,
        true
      ).then(() => {
        navigate(sessionStorage.getItem('targetUrl') || "/dashboard")
      })
    } else {
      setState(prevState => ({
        ...prevState,
        message: { text: res.data, variant: "danger" },
        loading: false,
      }))
    }
  })
}
